import React, { type FC, type ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import { Sheet, SheetContent, SheetContentProps, SheetProps } from '../sheet/index';

export type ModalVariantProps = { className?: string } & SheetProps;

export type ModalWrapperProps = {
  children: ReactNode;
  className?: string;
  control?: Except<SheetProps, 'children'>;
  disabledBgAutoClose?: true;
  onBgClick?: () => void;
  onInteractOutside?: SheetContentProps['onInteractOutside'];
} & Except<SheetContentProps, 'className' | 'onInteractOutside'>;

export const ModalWrapper: FC<ModalWrapperProps> = ({
  children,
  className,
  control,
  onBgClick,
  disabledBgAutoClose,
  onInteractOutside: onInteractOutsideProp,
  ...props
}) => {
  return (
    <Sheet {...control}>
      <SheetContent
        className={twMerge('border-none bg-transparent p-0', className)}
        onInteractOutside={(e) => {
          onInteractOutsideProp?.(e);
          if (disabledBgAutoClose) e.preventDefault();
          onBgClick?.();
        }}
        {...props}
      >
        {children}
      </SheetContent>
    </Sheet>
  );
};
